
const accordionItems = document.querySelectorAll('.accordion__item');

if (accordionItems) {
    accordionItems.forEach((accordion) => {
        const accordionHeader = accordion.querySelector('.accordion__header');
        accordionHeader.addEventListener('click', (e) => toggleAccordion(e));
    });
}

const toggleAccordion = (e) => {
    const item = e.currentTarget.closest('.accordion__item');
    const content = item.querySelector('.accordion__content');
    const isExpanded = item.classList.contains('accordion__item--is-expanded');

    // Collapse all items first
    accordionItems.forEach((el) => {
        el.classList.remove('accordion__item--is-expanded');
        el.querySelector('.accordion__content').setAttribute('data-visible', false);
    });

    // If the clicked item was already open, stop here
    if (isExpanded) return;

    // Otherwise, expand the clicked one
    item.classList.add('accordion__item--is-expanded');
    content.setAttribute('data-visible', true);
};
